// // // // // import React, { useEffect, useState } from "react";
// // // // // import "./AssignedOrdersTable.css"; // Import the external CSS

// // // // // function AssignedOrdersTable() {
// // // // //   const [orders, setOrders] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [error, setError] = useState(null);

// // // // //   useEffect(() => {
// // // // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/bookingassigned.php") // <-- Replace URL
// // // // //       .then((res) => {
// // // // //         if (!res.ok) throw new Error("Failed to fetch orders");
// // // // //         return res.json();
// // // // //       })
// // // // //       .then((data) => {
// // // // //         setOrders(data);
// // // // //         setLoading(false);
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         setError(err.message || "Unknown error");
// // // // //         setLoading(false);
// // // // //       });
// // // // //   }, []);

// // // // //   if (loading)
// // // // //     return React.createElement("p", null, "Loading orders...");

// // // // //   if (error)
// // // // //     return React.createElement(
// // // // //       "p",
// // // // //       { className: "assigned-orders-error" },
// // // // //       "Error: ",
// // // // //       error
// // // // //     );

// // // // //   if (orders.length === 0)
// // // // //     return React.createElement(
// // // // //       "p",
// // // // //       { className: "assigned-orders-no-data" },
// // // // //       "No assigned orders found."
// // // // //     );

// // // // //   const headers = [
// // // // //     "Id",
// // // // //     "Name",
// // // // //     "Email",
// // // // //     "Address",
// // // // //     "Main Service",
// // // // //     "Sub Service Title",
// // // // //     "Custom Title",
// // // // //     "Custom Description",
// // // // //     "Booked At",
// // // // //     "Image",
// // // // //     "Original Price",
// // // // //     "Discount Price",
// // // // //     "Discount Percent",
// // // // //     "Order Status",
// // // // //     "Assigned Employee ID",
// // // // //   ];

// // // // //   const thead = React.createElement(
// // // // //     "thead",
// // // // //     null,
// // // // //     React.createElement(
// // // // //       "tr",
// // // // //       null,
// // // // //       headers.map((header) =>
// // // // //         React.createElement("th", { key: header }, header)
// // // // //       )
// // // // //     )
// // // // //   );

// // // // //   const tbody = React.createElement(
// // // // //     "tbody",
// // // // //     null,
// // // // //     orders.map((order) =>
// // // // //       React.createElement(
// // // // //         "tr",
// // // // //         { key: order.id },
// // // // //         React.createElement("td", null, order.id),
// // // // //         React.createElement("td", null, order.name),
// // // // //         React.createElement("td", null, order.email),
// // // // //         React.createElement("td", null, order.address),
// // // // //         React.createElement("td", null, order.main_service),
// // // // //         React.createElement("td", null, order.sub_service_title),
// // // // //         React.createElement("td", null, order.custom_title || "-"),
// // // // //         React.createElement("td", null, order.custom_description || "-"),
// // // // //         React.createElement(
// // // // //           "td",
// // // // //           null,
// // // // //           new Date(order.booked_at).toLocaleString()
// // // // //         ),
// // // // //         React.createElement(
// // // // //           "td",
// // // // //           null,
// // // // //           order.image_url
// // // // //             ? React.createElement("img", {
// // // // //                 src: order.image_url,
// // // // //                 alt: order.sub_service_title || "Image",
// // // // //               })
// // // // //             : "-"
// // // // //         ),
// // // // //         React.createElement("td", null, order.original_price),
// // // // //         React.createElement("td", null, order.discount_price),
// // // // //         React.createElement(
// // // // //           "td",
// // // // //           null,
// // // // //           order.discount_percent ? order.discount_percent + "%" : "-"
// // // // //         ),
// // // // //         React.createElement("td", null, order.order_status),
// // // // //         React.createElement("td", null, order.assigned_employee_id || "-")
// // // // //       )
// // // // //     )
// // // // //   );

// // // // //   return React.createElement(
// // // // //     "div",
// // // // //     { className: "assigned-orders-container" },
// // // // //     React.createElement(
// // // // //       "table",
// // // // //       { className: "assigned-orders-table" },
// // // // //       thead,
// // // // //       tbody
// // // // //     )
// // // // //   );
// // // // // }

// // // // // export default AssignedOrdersTable;



// // // // // import React, { useEffect, useState } from "react";
// // // // // import "./AssignedOrdersTable.css";

// // // // // function AssignedOrdersTable() {
// // // // //   const [orders, setOrders] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [error, setError] = useState(null);

// // // // //   useEffect(() => {
// // // // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/bookingassigned.php")
// // // // //       .then((res) => {
// // // // //         if (!res.ok) throw new Error("Failed to fetch orders");
// // // // //         return res.json();
// // // // //       })
// // // // //       .then((data) => {
// // // // //         setOrders(data);
// // // // //         setLoading(false);
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         setError(err.message || "Unknown error");
// // // // //         setLoading(false);
// // // // //       });
// // // // //   }, []);

// // // // //   if (loading)
// // // // //     return <p className="assigned-orders-loading">Loading orders...</p>;

// // // // //   if (error)
// // // // //     return <p className="assigned-orders-error">Error: {error}</p>;

// // // // //   if (orders.length === 0)
// // // // //     return <p className="assigned-orders-no-data">No assigned orders found.</p>;

// // // // //   const headers = [
// // // // //     "Id",
// // // // //     "Name",
// // // // //     "Email",
// // // // //     "Address",
// // // // //     "Main Service",
// // // // //     "Sub Service Title",
// // // // //     "Custom Title",
// // // // //     "Custom Description",
// // // // //     "Booked At",
// // // // //     "Image",
// // // // //     "Original Price",
// // // // //     "Discount Price",
// // // // //     "Discount Percent",
// // // // //     "Order Status",
// // // // //     "Assigned Employee ID",
// // // // //   ];

// // // // //   return (
// // // // //     <div className="assigned-orders-wrapper">
// // // // //       <table className="assigned-orders-grid">
// // // // //         <thead>
// // // // //           <tr>
// // // // //             {headers.map((header) => (
// // // // //               <th key={header}>{header}</th>
// // // // //             ))}
// // // // //           </tr>
// // // // //         </thead>
// // // // //         <tbody>
// // // // //           {orders.map((order) => (
// // // // //             <tr key={order.id}>
// // // // //               <td>{order.id}</td>
// // // // //               <td>{order.name}</td>
// // // // //               <td>{order.email}</td>
// // // // //               <td>{order.address}</td>
// // // // //               <td>{order.main_service}</td>
// // // // //               <td>{order.sub_service_title}</td>
// // // // //               <td>{order.custom_title || "-"}</td>
// // // // //               <td>{order.custom_description || "-"}</td>
// // // // //               <td>{new Date(order.booked_at).toLocaleString()}</td>
// // // // //               <td>
// // // // //                 {order.image_url ? (
// // // // //                   <img src={order.image_url} alt={order.sub_service_title || "Image"} />
// // // // //                 ) : (
// // // // //                   "-"
// // // // //                 )}
// // // // //               </td>
// // // // //               <td>{order.original_price}</td>
// // // // //               <td>{order.discount_price}</td>
// // // // //               <td>{order.discount_percent ? order.discount_percent + "%" : "-"}</td>
// // // // //               <td>
// // // // //                 <span className={`assigned-orders-status ${order.order_status}`}>
// // // // //                   {order.order_status}
// // // // //                 </span>
// // // // //               </td>
// // // // //               <td>{order.assigned_employee_id || "-"}</td>
// // // // //             </tr>
// // // // //           ))}
// // // // //         </tbody>
// // // // //       </table>
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // export default AssignedOrdersTable;



// // // // import React, { useEffect, useState } from "react";
// // // // import "./EmployeeWorkflowTable.css";

// // // // const workflowStages = [
// // // //   "assigned",
// // // //   "on the way",
// // // //   "reached",
// // // //   "work started",
// // // //   "work completed",
// // // // ];

// // // // function EmployeeWorkflowTable() {
// // // //   const [orders, setOrders] = useState([]);
// // // //   const [employees, setEmployees] = useState([]);
// // // //   const [loading, setLoading] = useState(true);

// // // //   useEffect(() => {
// // // //     // Fetch all orders
// // // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php")
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.status === "success") {
// // // //           setOrders(data.data);
// // // //         }
// // // //       })
// // // //       .catch(console.error);

// // // //     // Fetch employees
// // // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php?type=employees")
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.status === "success") setEmployees(data.data);
// // // //         setLoading(false);
// // // //       })
// // // //       .catch(console.error);
// // // //   }, []);

// // // //   if (loading) return <p className="loading-text">Loading...</p>;

// // // //   return (
// // // //     <div className="workflow-table-container">
// // // //       <h2>Employee Workflow Overview</h2>
// // // //       <table className="workflow-table">
// // // //         <thead>
// // // //           <tr>
// // // //             <th>Employee ID</th>
// // // //             <th>Employee Name</th>
// // // //             {workflowStages.map((stage) => (
// // // //               <th key={stage}>{stage.replace(/_/g, " ")}</th>
// // // //             ))}
// // // //           </tr>
// // // //         </thead>
// // // //         <tbody>
// // // //           {employees.map((emp) => {
// // // //             const empOrders = orders.filter((o) => o.assigned_employee_id === emp.employee_id);
// // // //             const completedCount = empOrders.filter((o) => o.order_status === "work completed").length;

// // // //             return (
// // // //               <tr key={emp.employee_id}>
// // // //                 <td>{emp.employee_id}</td>
// // // //                 <td>{emp.full_name}</td>
// // // //                 {workflowStages.map((stage) => {
// // // //                   if (stage === "work completed") return <td key={stage}>{completedCount}</td>;

// // // //                   const inStage = empOrders.some((o) => o.order_status === stage);
// // // //                   return <td key={stage}>{inStage ? "Yes" : "-"}</td>;
// // // //                 })}
// // // //               </tr>
// // // //             );
// // // //           })}
// // // //         </tbody>
// // // //       </table>
// // // //     </div>
// // // //   );
// // // // }

// // // // export default EmployeeWorkflowTable;


// // // import React, { useEffect, useState } from "react";
// // // import "./EmployeeStatusTable.css";

// // // const stages = ["assigned", "on the way", "reached", "work started", "work completed"];

// // // function EmployeeStatusTable() {
// // //   const [orders, setOrders] = useState([]);
// // //   const [employees, setEmployees] = useState([]);
// // //   const [loading, setLoading] = useState(true);

// // //   useEffect(() => {
// // //     // Fetch all orders
// // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php")
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (data.status === "success") setOrders(data.data);
// // //       })
// // //       .catch(console.error);

// // //     // Fetch employees
// // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php?type=employees")
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (data.status === "success") setEmployees(data.data);
// // //         setLoading(false);
// // //       })
// // //       .catch(console.error);
// // //   }, []);

// // //   if (loading) return <p className="est-loading-text">Loading data...</p>;

// // //   return (
// // //     <div className="est-container">
// // //       <h2 className="est-title">Employee Workflow Status</h2>
// // //       <table className="est-table">
// // //         <thead>
// // //           <tr className="est-header-row">
// // //             <th>Employee ID</th>
// // //             <th>Employee Name</th>
// // //             {stages.map((stage) => (
// // //               <th key={stage}>{stage.replace(/_/g, " ")}</th>
// // //             ))}
// // //           </tr>
// // //         </thead>
// // //         <tbody>
// // //           {employees.map((emp) => {
// // //             const empOrders = orders.filter((o) => o.assigned_employee_id === emp.employee_id);
// // //             const completedCount = empOrders.filter((o) => o.order_status === "work completed").length;

// // //             return (
// // //               <tr key={emp.employee_id} className="est-body-row">
// // //                 <td>{emp.employee_id}</td>
// // //                 <td>{emp.full_name}</td>
// // //                 {stages.map((stage) => {
// // //                   if (stage === "work completed") return <td key={stage}>{completedCount}</td>;
// // //                   const inStage = empOrders.some((o) => o.order_status === stage);
// // //                   return <td key={stage}>{inStage ? "Yes" : "-"}</td>;
// // //                 })}
// // //               </tr>
// // //             );
// // //           })}
// // //         </tbody>
// // //       </table>
// // //     </div>
// // //   );
// // // }

// // // export default EmployeeStatusTable;



// // import React, { useEffect, useState } from "react";
// // import "./EmployeeWorkflowTable.css";

// // const stages = ["assigned", "on the way", "reached", "work started", "work completed"];

// // function EmployeeWorkflowTable() {
// //   const [orders, setOrders] = useState([]);
// //   const [employees, setEmployees] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     // Fetch employees
// //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php?type=employees")
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.status === "success") setEmployees(data.data);
// //       })
// //       .catch(console.error);

// //     // Fetch orders
// //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php")
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.status === "success") setOrders(data.data);
// //         setLoading(false);
// //       })
// //       .catch(console.error);
// //   }, []);

// //   if (loading) return <p className="ewt-loading">Loading...</p>;

// //   return (
// //     <div className="ewt-container">
// //       <h2 className="ewt-title">Employee Workflow Status</h2>
// //       <div className="ewt-table-wrapper">
// //         <table className="ewt-table">
// //           <thead>
// //             <tr>
// //               <th>Employee ID</th>
// //               <th>Employee Name</th>
// //               {stages.map((stage) => (
// //                 <th key={stage}>{stage.replace(/_/g, " ")}</th>
// //               ))}
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {employees.map((emp) => {
// //               const empOrders = orders.filter((o) => o.assigned_employee_id === emp.employee_id);
// //               const completedCount = empOrders.filter((o) => o.order_status === "work completed").length;

// //               return (
// //                 <tr key={emp.employee_id}>
// //                   <td>{emp.employee_id}</td>
// //                   <td>{emp.full_name}</td>
// //                   {stages.map((stage) => {
// //                     if (stage === "work completed") return <td key={stage}>{completedCount}</td>;

// //                     const inStage = empOrders.some((o) => o.order_status === stage);
// //                     return <td key={stage}>{inStage ? "Yes" : "-"}</td>;
// //                   })}
// //                 </tr>
// //               );
// //             })}
// //           </tbody>
// //         </table>
// //       </div>
// //     </div>
// //   );
// // }

// // export default EmployeeWorkflowTable;


// import React, { useEffect, useState } from "react";
// import "./EmployeeWorkflowTable.css"; // Fully scoped CSS

// const workflowStages = [
//   "assigned",
//   "on the way",
//   "reached",
//   "work started",
//   "work completed",
// ];

// function EmployeeWorkflowTable() {
//   const [orders, setOrders] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Fetch employees
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php?type=employees")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") setEmployees(data.data);
//       })
//       .catch(console.error);

//     // Fetch all bookings/orders
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") setOrders(data.data);
//         setLoading(false);
//       })
//       .catch(console.error);
//   }, []);

//   if (loading) return <p className="ewt-container ewt-loading">Loading data...</p>;

//   return (
//     <div className="ewt-container">
//       <h2 className="ewt-title">Employee Workflow Status</h2>
//       <div className="ewt-table-wrapper">
//         <table className="ewt-table">
//           <thead>
//             <tr>
//               <th>Employee ID</th>
//               <th>Employee Name</th>
//               {workflowStages.map((stage) => (
//                 <th key={stage}>{stage.replace(/_/g, " ")}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {employees.map((emp) => {
//               // Filter all orders assigned to this employee
//               const empOrders = orders.filter((o) => o.assigned_employee_id === emp.employee_id);

//               // Count completed orders
//               const completedCount = empOrders.filter((o) => o.order_status === "work completed").length;

//               return (
//                 <tr key={emp.employee_id}>
//                   <td>{emp.employee_id}</td>
//                   <td>{emp.full_name}</td>
//                   {workflowStages.map((stage) => {
//                     if (stage === "work completed") {
//                       return <td key={stage}>{completedCount}</td>;
//                     }
//                     const inStage = empOrders.some((o) => o.order_status === stage);
//                     return <td key={stage}>{inStage ? "Yes" : "-"}</td>;
//                   })}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default EmployeeWorkflowTable;







// import React, { useEffect, useState } from "react";

// const workflowStages = [
//   "assigned",
//   "on the way",
//   "reached",
//   "work started",
//   "work completed",
// ];

// function EmployeeWorkflowTableInline() {
//   const [orders, setOrders] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Fetch employees
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php?type=employees")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") setEmployees(data.data);
//       })
//       .catch(console.error);

//     // Fetch all bookings/orders
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") setOrders(data.data);
//         setLoading(false);
//       })
//       .catch(console.error);
//   }, []);

//   if (loading) return <p style={{ textAlign: "center", padding: "50px 0", fontSize: "16px", color: "#555" }}>Loading data...</p>;

//   // Inline styles
//   const containerStyle = {
//     width: "95%",
//     margin: "30px auto",
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     padding: "20px",
//     boxShadow: "0 6px 15px rgba(0, 0, 0, 0.08)",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     overflowX: "auto",
//   };

//   const titleStyle = {
//     textAlign: "center",
//     fontSize: "24px",
//     marginBottom: "20px",
//     color: "#1c1c1c",
//     fontWeight: 600,
//   };

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     minWidth: "900px",
//   };

//   const thStyle = {
//     padding: "14px 12px",
//     fontSize: "14px",
//     textTransform: "uppercase",
//     letterSpacing: "0.5px",
//     backgroundColor: "#2e86de",
//     color: "#fff",
//     border: "1px solid #fff",
//   };

//   const tdStyle = {
//     padding: "12px",
//     textAlign: "center",
//     fontSize: "14px",
//     border: "1px solid #ddd",
//     fontWeight: 500,
//   };

//   const rowStyle = (index) => ({
//     backgroundColor: index % 2 === 0 ? "#f1f5f8" : "#fff",
//     transition: "background 0.3s",
//   });

//   const rowHoverStyle = {
//     backgroundColor: "#d6e6ff",
//   };

//   const yesStyle = { color: "#27ae60", fontWeight: 600 };

//   return (
//     <div style={containerStyle}>
//       <h2 style={titleStyle}>Employee Workflow Status</h2>
//       <div style={{ overflowX: "auto" }}>
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={thStyle}>Employee ID</th>
//               <th style={thStyle}>Employee Name</th>
//               {workflowStages.map((stage) => (
//                 <th key={stage} style={thStyle}>
//                   {stage.replace(/_/g, " ")}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {employees.map((emp, index) => {
//               const empOrders = orders.filter((o) => o.assigned_employee_id === emp.employee_id);
//               const completedCount = empOrders.filter((o) => o.order_status === "work completed").length;

//               return (
//                 <tr key={emp.employee_id} style={rowStyle(index)}
//                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#d6e6ff")}
//                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f1f5f8" : "#fff")}
//                 >
//                   <td style={tdStyle}>{emp.employee_id}</td>
//                   <td style={tdStyle}>{emp.full_name}</td>
//                   {workflowStages.map((stage) => {
//                     if (stage === "work completed") return <td key={stage} style={tdStyle}>{completedCount}</td>;
//                     const inStage = empOrders.some((o) => o.order_status === stage);
//                     return <td key={stage} style={inStage ? { ...tdStyle, ...yesStyle } : tdStyle}>{inStage ? "Yes" : "-"}</td>;
//                   })}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default EmployeeWorkflowTableInline;








// shaiksha added








import React, { useEffect, useState } from "react";

const workflowStages = [
  "assigned",
  "on the way",
  "reached",
  "work started",
  "work completed",
];

export default function EmployeeWorkflowTableInline() {
  const [orders, setOrders] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    fetchEmployees();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const fetchEmployees = async () => {
    try {
      const empRes = await fetch(
        "https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php?type=employees"
      );
      const empData = await empRes.json();
      if (empData.status === "success") setEmployees(empData.data);

      const orderRes = await fetch(
        "https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php"
      );
      const orderData = await orderRes.json();
      if (orderData.status === "success") setOrders(orderData.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleEmployeeSelect = (e) => {
    const employeeId = e.target.value;
    const emp = employees.find((emp) => emp.employee_id === employeeId); // ✅ match as string
    setSelectedEmployee(emp || null);
  };

  if (loading)
    return (
      <p
        style={{
          textAlign: "center",
          padding: "40px",
          fontSize: "16px",
          color: "#555",
        }}
      >
        Loading data...
      </p>
    );

  const containerStyle = {
    width: "100%",
    margin: "10px auto",
    marginLeft: 0,
    background: "#fff",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    fontFamily: "sans-serif",
  };

  const thStyle = {
    padding: "10px",
    background: "#2e86de",
    color: "#fff",
    border: "1px solid #fff",
  };

  const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const yesStyle = { color: "#27ae60", fontWeight: "bold" };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
        Employee Workflow Status
      </h2>

      {/* ✅ Dropdown for small screens only */}
      {windowWidth < 768 && (
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Select Employee:
          </label>
          <select
            style={{
              padding: "10px",
              width: "100%",
              borderRadius: "5px",
            
              border: "1px solid #121111ff",
            }}
            value={selectedEmployee?.employee_id || ""}
            onChange={handleEmployeeSelect}
          >
            <option value="">-- Choose an Employee --</option>
            {employees.map((emp) => (
              <option key={emp.employee_id} value={emp.employee_id}>
                {emp.full_name} (ID: {emp.employee_id})
              </option>
            ))}
          </select>
        </div>
      )}

      {/* ✅ Show selected employee's details */}
      {windowWidth < 768 && selectedEmployee && (
        <div style={{ marginTop: "20px" }}>
         <h3> NAME: {selectedEmployee.full_name}</h3>
          <p>Employee ID: {selectedEmployee.employee_id}</p>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Stage</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {workflowStages.map((stage) => {
                const inStage = orders.some(
                  (order) =>
                    order.assigned_employee_id === selectedEmployee.employee_id &&
                    order.order_status === stage
                );
                return (
                  <tr key={stage}>
                    <td style={tdStyle}>{stage}</td>
                    <td style={inStage ? { ...tdStyle, ...yesStyle } : tdStyle}>
                      {inStage ? "Yes" : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ✅ Full table for large screens */}
      {windowWidth >= 768 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Employee ID</th>
                <th style={thStyle}>Employee Name</th>
                {workflowStages.map((stage) => (
                  <th key={stage} style={thStyle}>
                    {stage}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, idx) => {
                const empOrders = orders.filter(
                  (o) => o.assigned_employee_id === emp.employee_id
                );
                return (
                  <tr key={emp.employee_id}>
                    <td style={tdStyle}>{emp.employee_id}</td>
                    <td style={tdStyle}>{emp.full_name}</td>
                    {workflowStages.map((stage) => {
                      const inStage = empOrders.some(
                        (o) => o.order_status === stage
                      );
                      return (
                        <td
                          key={stage}
                          style={inStage ? { ...tdStyle, ...yesStyle } : tdStyle}
                        >
                          {inStage ? "Yes" : "-"}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
